$('.featured_slider').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: false,
		navText: ["Prev","Next"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:4
	        },
	        1100:{
	            items:4
	        }
	    }
}); 
$('.test_slider_s').owlCarousel({
	     margin:30,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: false,
		navText: ["Prev","Next"],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:2
	        }
	    }
}); 

setTimeout(function() {
        jQuery('.releted-slider').owlCarousel({
            margin: 30,
            loop: true,
            slideSpeed: 300,
            paginationSpeed: 400,
            autoplay: false,
            nav: false,
            pagination: false,
            dots: false,
            navText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 1
                },
                768: {
                    items: 2
                },
                1000: {
                    items: 3
                },
                1100: {
                    items: 3
                }
            }

        });
    }, 3000);

// FAQs  Js
    jQuery(".accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
$(document).on("click",".next_prev_btns .prev_arrow",function(){
  $(this).closest("section").find(".owl-prev").trigger("click");
});

$(document).on("click",".next_prev_btns .next_arrow",function(){
  $(this).closest("section").find(".owl-next").trigger("click");
});

$(document).on("change",".home_featured_product .select__select",function(){
 if($(this).val()=="5")
 {
   $("a.product-form__submit.button.view_meal_plan").attr("href","/products/subscription-5-meal-pack");
 }
  else if($(this).val()=="10")
 {
   $("a.product-form__submit.button.view_meal_plan").attr("href","/products/subscription-10-meal-pack");
 }
   else if($(this).val()=="15")
 {
   $("a.product-form__submit.button.view_meal_plan").attr("href","/products/15-meal-pack-subscription");
 }
   else if($(this).val()=="20")
 {
   $("a.product-form__submit.button.view_meal_plan").attr("href","/products/20-meal-pack-subscription");
 }
});

// Add to Cart Bar
function bottomPriceChange() {
    if($(".add_cart_bar_section").length>0)
    {
    	setTimeout(function() {
          
    		var prices = parseFloat($(".cart-drawer__footer .totals__total-value").text().replace("$", "")).toFixed(2);
           
            
    		var meal_number = $(".cart-count-bubble span:first-child").text();
            if ($(".cart-count-bubble span").length > 0)
            {
               $(".add_cart_bar_section").show();
              $(".add_cart_bar_section .add_cart_bar .meals_box span.meal_num span").text(meal_number);
            }
            else
            {
              $(".add_cart_bar_section").hide();
            }
              
    		
    		var remaining_prices = parseFloat(250.00 - prices).toFixed(2);
    		if (remaining_prices > 0) {
    			$(".progress_area .purchase_box").html('$<span class="remaining_items">' + prices + '</span> Order Total. (FREE Delivery over $250)');
    			//$(".progress_area .purchase_box").html("Purchase $<span class='remaining_items'>" + remaining_prices + "</span> to get Free Shipping");
    		} else {
    			$(".progress_area .purchase_box").html("Congratulations You are Eligable For the Free Shipping");
    		}
    		var percentage = parseFloat((prices / 250.00) * 100).toFixed(2);
    		$(".add_cart_bar_section .add_cart_bar .progress_bar span").css({
    			"width": "" + percentage + "%"
    		});
    		if ($("body").hasClass("boost-pfs-enable-instant-search")) {
    			$(".add_cart_bar_section").show();
    		}
    	}, 2000);
      }
}
jQuery(document).on("click", ".boost-pfs-addtocart-btn,.boost-pfs-minicart-item-quantity-minus,.boost-pfs-minicart-item-quantity-plus,.boost-pfs-minicart-item-remove-text", function() {
	bottomPriceChange();
});

function cart_number_change(cart_attr) {
	setTimeout(function() {
		var cart_number = parseInt($('.boost-pfs-minicart-item[data-title="' + cart_attr + '"] .boost-pfs-minicart-item-quantity').val());
		if (cart_number > 0) {
			$('.boost-pfs-filter-product-item[data-title="' + cart_attr + '"]  .boost_product_cart_overlay').html("<span>" + cart_number + "</span>").show();
			$('.boost-pfs-filter-product-item[data-title="' + cart_attr + '"]  .pricing_qty_col .qty_items input').val(cart_number);
		} else {
			$('.boost-pfs-filter-product-item[data-title="' + cart_attr + '"]  .boost_product_cart_overlay').hide();
          $('.boost-pfs-filter-product-item[data-title="' + cart_attr + '"]  .pricing_qty_col .qty_items input').val(0);
		}
	}, 1000);
}

jQuery(document).on("click", ".boost-pfs-addtocart-btn", function() {
	var attr_product = $(this).closest(".boost-pfs-filter-product-item").attr("data-title");
	cart_number_change(attr_product);
});

jQuery(document).on("click", ".boost-pfs-minicart-item-quantity-minus,.boost-pfs-minicart-item-quantity-plus,.boost-pfs-minicart-item-remove-text", function() {
	var attr_product = $(this).closest(".boost-pfs-minicart-item").attr("data-title");
	cart_number_change(attr_product);
});

setInterval(function() {
	$(".boost-pfs-enable-instant-search .boost-pfs-minicart-item").each(function() {
		var attr_cart = $(this).attr("data-title");
		cart_number_change(attr_cart);
	});
	bottomPriceChange();
    $(".boost-pfs-checkout-action .boost-pfs-viewcart a").html("Checkout");
}, 1000);


/* Quantity Listing Plus Minus*/

jQuery(document).on("click",".pricing_qty_col .qty_items a.minus_pro_item", function(){
  var attr_product = $(this).closest(".boost-pfs-filter-product-item").attr("data-title");
  var cart_number = parseInt($(this).closest(".boost-pfs-filter-product-item").find(".pricing_qty_col").find("input").val());
    if (cart_number > 1) {
        $('.boost-pfs-minicart-item[data-title="' + attr_product + '"] .boost-pfs-minicart-item-quantity-minus').trigger("click");
      
    } 
    else {
		 $('.boost-pfs-minicart-item[data-title="' + attr_product + '"] .boost-pfs-minicart-item-remove').trigger("click");
        $(this).closest(".boost-pfs-filter-product-item").find(".pricing_qty_col").find("input").val(0);
	 }
});
 
jQuery(document).on("click",".pricing_qty_col .qty_items a.plus_pro_item", function(){
  var attr_product = $(this).closest(".boost-pfs-filter-product-item").attr("data-title");
  var cart_number = parseInt($(this).closest(".boost-pfs-filter-product-item").find(".pricing_qty_col").find("input").val());
    if (cart_number > 0) {
        $('.boost-pfs-minicart-item[data-title="' + attr_product + '"] .boost-pfs-minicart-item-quantity-plus').trigger("click");
    } 
    else {
		 $(this).closest(".boost-pfs-filter-product-item").find(".boost-pfs-addtocart-btn").trigger("click");
	 }
});